import { Deserializable } from '../../protocols/deserializable';
import type { Orientation } from '../../enum/dto/orientation.enum';
import type { CardSize } from '../../enum/dto/card-size';
import { PrintCardProperty } from 'src/app/utils/print-card-property-definition';

export class PrintConfig implements Deserializable {
  public marginBottom: number;
  public marginLeft: number;
  public marginRight: number;
  public marginTop: number;
  public paperSizes: string[];
  public printCardSizes: string[];
  public orientations: string[];
  public cardOrientationMap: Map<CardSize, Orientation>;
  public gridCountMap: Map<CardSize, number>;
  public visibleCompoundMap: Map<CardSize, number>;
  public visiblePropertyMap: Map<CardSize, PrintCardProperty[]>;

  onDeserialize() {
    this.cardOrientationMap = window?.injector?.Deserialize.genericMap(this.cardOrientationMap);
    this.gridCountMap = window?.injector?.Deserialize.genericMap(this.gridCountMap);
    this.visibleCompoundMap = window?.injector?.Deserialize.genericMap(this.visibleCompoundMap);
    this.visiblePropertyMap = window?.injector?.Deserialize.genericMap(this.visiblePropertyMap);
  }
}
